import { Link } from "react-router-dom";
import peopleMatterIcon from "../assets/icons/people_matter_couple_heart.svg";

interface AboutUsNavItemProps {
  onClick: () => void;
  isActive: (path: string) => boolean;
}

const AboutUsNavItem = ({ onClick, isActive }: AboutUsNavItemProps) => {
  return (
    <li className="flex items-center space-x-2 pt-2">
      <img src={peopleMatterIcon} alt="A map" className="w-6 h-6 mr-1" />
      <Link
        onClick={onClick}
        to="/about-us"
        className={`${isActive("/about-us") ? "font-bold text-blue-500" : ""}`}
      >
        <span>About Us</span>
      </Link>
    </li>
  );
};

export default AboutUsNavItem;
